import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useScopePlannedCompleted } from '../../../hooks/analytics/useScopeReports.ts';
import { ProgressBar, StatCard, WidgetCard } from '../controller/shared.tsx';

/** `scope_planned_completed` — planned vs. completed testing progress bar. */
export const ScopePlannedCompletedChart: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useScopePlannedCompleted();
  const pct = data ? Math.max(0, Math.min(100, data.completion_pct)) : 0;

  return (
    <WidgetCard
      title="Planned vs. Completed"
      description="Testing progress against the planned/scheduled population"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load planned-vs-completed testing.'}
      isEmpty={!isLoading && !isError && !data}
      emptyMessage="No testing planned yet."
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <div className="space-y-4">
        <div>
          <div className="mb-1.5 flex items-center justify-between text-sm">
            <span className="font-medium text-slate-700">{data?.completed ?? 0} of {data?.planned ?? 0} completed</span>
            <span className="font-semibold text-slate-900">{pct.toFixed(0)}%</span>
          </div>
          <ProgressBar pct={pct} colorClass="bg-emerald-500" />
        </div>
        <div className="analytics-kpi-grid gap-3">
          <StatCard title="Planned" value={data?.planned ?? 0} color="bg-blue-100 text-blue-600" />
          <StatCard
            title="Completed"
            value={data?.completed ?? 0}
            icon={<CheckCircle2 className="h-5 w-5" />}
            color="bg-emerald-100 text-emerald-600"
          />
        </div>
      </div>
    </WidgetCard>
  );
};

export default ScopePlannedCompletedChart;
